import { AcceptInviteForm } from '@/features/auth';

export default function AcceptInvitePage() {
  return <AcceptInviteForm />;
}
